<template>
  <div
    class="progress-ring"
    :data-progress="progress"
    :class="{ 'show-digits': digits }"
    :style="{ '--height': 2 * radius + 'px', '--color': color }"
  >
    <svg :height="radius * 2" :width="radius * 2">
      <circle
        :stroke="color"
        opacity=".2"
        fill="transparent"
        :stroke-width="stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
      <circle
        :stroke="color"
        fill="transparent"
        stroke-linecap="round"
        :stroke-dasharray="circumference + ' ' + circumference"
        :style="{ strokeDashoffset: strokeDashoffset }"
        :stroke-width="stroke"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    radius: { type: Number, default: 100 },
    progress: { type: Number, default: 50 },
    stroke: { type: Number, default: 10 },
    color: { type: String, default: 'black' },
    digits: { type: Boolean, default: true },
    max: { type: Number, default: 100 }
  },

  data() {
    const normalizedRadius = this.radius - this.stroke * 2
    const circumference = normalizedRadius * 2 * Math.PI

    return {
      normalizedRadius,
      circumference
    }
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - (this.progress / 100) * this.circumference
    }
  }
}
</script>
